import { render, staticRenderFns } from "./ContainerCategoryForm.vue?vue&type=template&id=239f15b0"
import script from "./ContainerCategoryForm.vue?vue&type=script&lang=js"
export * from "./ContainerCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports